module.exports = __webpack_public_path__ + "static/media/South_Station_Line.94cf112c.svg";